import { createApp } from 'vue';
import App from './App.vue';
import { createI18n } from 'vue-i18n';
import router from './router.js';
import 'bootstrap/dist/css/bootstrap.css';
import '../public/assets/css/main.css';
import bootstrap from 'bootstrap/dist/js/bootstrap.min.js';

// Create i18n instance with an empty messages object
const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || 'en', // Load saved locale or default to 'en'
  fallbackLocale: 'en', // Fallback locale
  messages: {} // Start with empty messages
});

// Function to load locale messages from the public folder
async function loadLocaleMessages(locale) {
  try {
    const response = await fetch(`/locales/${locale}.json`);
    if (!response.ok) throw new Error(`Locale file for ${locale} not found.`);
    
    const messages = await response.json();
    i18n.global.setLocaleMessage(locale, messages); // Set messages dynamically
  } catch (error) {
    console.error(`Error loading locale file for ${locale}:`, error);
  }
}

// Load the default locale before mounting the app
async function initializeApp() {
  const currentLocale = i18n.global.locale.value; // ✅ Correct way to get locale
  await loadLocaleMessages(currentLocale); // ✅ Load messages before mounting

  const app = createApp(App);
  app.use(router);
  app.use(bootstrap);
  app.use(i18n);
  app.mount('#app');
}

initializeApp();

export { i18n, loadLocaleMessages };
